var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleHighFive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Workflow-Teamwork-User-High-Five--Streamline-Ultimate",
    clipPath: "url(#clip0_32745_17404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.00488 16.5413C3.00488 17.6225 3.43439 18.6594 4.19891 19.4239C4.96343 20.1884 6.00035 20.6179 7.08155 20.6179C8.16275 20.6179 9.19966 20.1884 9.96419 19.4239C10.7287 18.6594 11.1582 17.6225 11.1582 16.5413C11.1582 15.4601 10.7287 14.4232 9.96419 13.6586C9.19966 12.8941 8.16275 12.4646 7.08155 12.4646C6.00035 12.4646 4.96343 12.8941 4.19891 13.6586C3.43439 14.4232 3.00488 15.4601 3.00488 16.5413Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.0918 16.5413C29.0918 17.0766 29.1972 17.6067 29.4021 18.1013C29.607 18.5959 29.9073 19.0454 30.2858 19.4239C30.6644 19.8025 31.1138 20.1027 31.6084 20.3076C32.103 20.5125 32.6331 20.6179 33.1685 20.6179C33.7038 20.6179 34.2339 20.5125 34.7285 20.3076C35.2231 20.1027 35.6726 19.8025 36.0511 19.4239C36.4297 19.0454 36.7299 18.5959 36.9348 18.1013C37.1397 17.6067 37.2451 17.0766 37.2451 16.5413C37.2451 16.0059 37.1397 15.4758 36.9348 14.9812C36.7299 14.4866 36.4297 14.0372 36.0511 13.6586C35.6726 13.2801 35.2231 12.9798 34.7285 12.7749C34.2339 12.57 33.7038 12.4646 33.1685 12.4646C32.6331 12.4646 32.103 12.57 31.6084 12.7749C31.1138 12.9798 30.6644 13.2801 30.2858 13.6586C29.9073 14.0372 29.607 14.4866 29.4021 14.9812C29.1972 15.4758 29.0918 16.0059 29.0918 16.5413Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.4582 39.1313V27.908C25.4104 27.7192 23.462 26.9377 21.8514 25.6589C20.2409 24.3802 19.0379 22.6597 18.3898 20.708L16.9865 16.4997C16.8739 16.1621 16.8363 15.804 16.8764 15.4504C16.9164 15.0969 17.033 14.7563 17.2182 14.4524C17.4034 14.1485 17.6526 13.8887 17.9485 13.6911C18.2444 13.4934 18.5799 13.3627 18.9315 13.308C19.5229 13.2349 20.1211 13.3722 20.6214 13.6958C21.1218 14.0194 21.4923 14.5087 21.6682 15.078L23.0315 19.1663C23.4102 20.3018 24.1367 21.2892 25.108 21.9886C26.0794 22.688 27.2462 23.0639 28.4432 23.063H35.6098C36.0382 23.0626 36.4625 23.1466 36.8584 23.3102C37.2543 23.4738 37.6141 23.7139 37.9172 24.0166C38.2202 24.3194 38.4607 24.6789 38.6247 25.0747C38.7887 25.4704 38.8732 25.8946 38.8732 26.323V39.138",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.5467 18.1697L17.2133 19.1597C16.8344 20.2975 16.1066 21.2869 15.1334 21.9876C14.1601 22.6883 12.9909 23.0646 11.7917 23.063H4.63333C3.77017 23.0635 2.94241 23.4062 2.3316 24.0161C1.72078 24.626 1.37677 25.4532 1.375 26.3163V39.1313",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.7915 39.1312V27.9079C14.2202 27.7757 15.6071 27.3542 16.8678 26.6692C18.1285 25.9841 19.2366 25.0497 20.1248 23.9229",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.2915 2.04785V5.38118",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.8152 5.52466L23.4585 7.88132",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.7686 5.52466L15.1252 7.88132",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32745_17404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.125 0.5896)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleHighFive);
export default __webpack_public_path__ + "static/media/peopleHighFive.d72c5f0e189ce089ec9cf46b9bb99758.svg";
export { ForwardRef as ReactComponent };